import { useQuery, useQueryClient } from "@tanstack/react-query";
import { BoosterApi } from "../types/Booster";
import { api } from "../utils/hostname";
import url from "../url";

export const useGetBoostersUser = () => {
  const queryClient = useQueryClient();
  const { data, isLoading, isPending } = useQuery({
    queryKey: ["boosters user"],
    queryFn: () =>
      api(true, true).get<{ data: BoosterApi[] }>(
        url.config.api.loyalty.userBoosters,
      ),
    refetchOnWindowFocus: false,
  });

  const invalidateBoosters = async () => {
    await queryClient.invalidateQueries({ queryKey: ["boosters user"] });
  };

  return {
    boosters: data?.data?.data || [],
    isLoading: isLoading || isPending,
    invalidateBoosters,
  };
};
